import { useEffect, useRef, useState } from "react";

export default function useInView(options = { threshold: 0.12, once: true }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (options.once) observer.disconnect();
        } else if (!options.once) {
          setInView(false);
        }
      },
      { threshold: options.threshold || 0.12, rootMargin: options.rootMargin || "0px 0px -80px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [options.threshold, options.once, options.rootMargin]);

  return [ref, inView];
}
